// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__RUG4W","section":"Panel_section__3F5hO","section__theme_dark":"Panel_section__theme_dark__302Ui","section__highlight":"Panel_section__highlight__1cZ8l"};